import { IS_CI } from '@dtx-company/true-common/src/constants/env'
import { SET_ACCESS_TOKEN_COOKIE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function setAccessTokenCookie(accessToken: string): Promise<void> {
  try {
    const res = await fetch(SET_ACCESS_TOKEN_COOKIE_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ accessToken })
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }

    //needed for connect rpc calls since they are hitting the staging APIs
    if (IS_CI) {
      await fetch('https://app.stg.flowcode.com/api/auth/set-access-token-cookie', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ accessToken })
      })
    }
  } catch (e) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
